/* eslint-disable */

/**
 * 0:正常
 * 1——1000：微服务框架预留错误码
 * 1000——2000：E5平台错误码，为了支持国际化，不直接返回错误信息，而是使用错误码。
 * 业务系统应该从10000开始定义错误码
 * 1001：实际数据已经不存在，如一篇稿件已经被删除
 * 1002：实际数据的状态已经发生改变，如一篇稿件已经被别人提交审批了
 * 1003：数据已经被别人锁定，别人正在处理中。
 **/

import axios from 'axios'
// newsedit 注释开始
import loading from './loading'
import { Message } from 'element-ui'
import Options from '@common/options.js'
import qs from 'qs'
import md5 from 'md5'
import store from '@/store'
import {
  objectToQueryString,
  manualDecode,
  getRandom11DigitNumber
} from './sm2'
import { sm3 } from 'sm-crypto'
// newsedit 注释结束

// 微服务后台工程名称
const microServiceProjects = [
  '/mediax-batman',
  '/mediax-system',
  '/mediax-site',
  '/mediax-articleapp',
  '/mediax-column',
  '/mediax-resource',
  '/mediax-image',
  '/mediax-column-web',
  '/mediax-paper',
  '/mediax-articleedit',
  '/mediax-video',
  '/mediax-articleorigin',
  '/mediax-articlewx',
  '/mediax-articlewb',
  '/mediax-wire',
  '/mediax-content',
  '/mediax-admin',
  '/mediax-articleaudit',
  '/mediax-mbd',
  '/mediax-content',
  '/mediax-materialpaper',
  '/mediax-materialspecial',
  '/mediax-open',
  '/mediax-nis-discuss',
  '/mediax-entry-app',
  '/mediax-push',
  '/mediax-nis-live',
  '/mediax-articlemy',
  '/mediax-fts',
  '/mediax-nis',
  '/mediax-articlevideo',
  '/mediax-stat',
  '/mediax-newsplan',
  '/mediax-asset',
  '/mediax-repository',
  '/mediax-job',
  '/mediax-journal', // 期刊
  '/prodb', // 调用‘会员管理’-‘会员列表’的时候，添加的
  '/prebatman',
  // '/batman', // PUGC投稿平台
  '/member' // PUGC投稿平台-会员
  // '/app', // PUGC投稿平台-上传
]
/**
 * @author Mr.Yang
 * @description: //TODO 给大数据接口配置白名单,401后不再登出。此处新增了针对云端稿库自动登录接口，登录失败导致的401错误
 * @date 2023-04-01 16:05
 */
const apiWhiteList = [
  '/mediax-mbd/api/',
  '/mediax-mbd/mbd-',
  '/mediax-system/e5/autologin'
]
const isMbdWhiteListApi = (url) => {
  return apiWhiteList.some((mbdApi) => url.indexOf(mbdApi) === 0)
}

const isMicroServiceApi = (url) => {
  return microServiceProjects.some(
    (projectName) => url.indexOf(projectName) === 0
  )
}
const outUrl = [
  '/mediax-system/permissions/channels',
  '/mediax-site/sites',
  '/mediax-column/columnwebs/root',
  '/mediax-column/columnwebs',
  '/mediax-column/columns/root',
  '/mediax-column/columns',
  '/mediax-articleorigin/e5/folders/by/docLibs',
  '/mediax-articleorigin/e5/folders',
  '/mediax-system/folder/root',
  '/mediax-column/columns/search',
  '/mediax-asset/e5/folders/by/docLibs',
  '/mediax-asset/e5/folders/children',
  '/mediax-column/columnwebs/search'
]
const versionInfo = window.localStorage.getItem('versionInfo')
let version = ''
if (versionInfo && versionInfo !== 'null') {
  version = JSON.parse(versionInfo).version
}
// 版本比较函数
const isVersionBelow = (version1, version2) => {
  const v1Parts = version1.split('.').map(Number)
  const v2Parts = version2.split('.').map(Number)
  const maxLength = Math.max(v1Parts.length, v2Parts.length)
  for (let i = 0; i < maxLength; i++) {
    const v1Part = v1Parts[i] || 0
    const v2Part = v2Parts[i] || 0
    if (v1Part > v2Part) {
      return 1
    } else if (v1Part < v2Part) {
      return -1
    }
  }
  return 0
}

/**
 * 规范化单个字符串值用于 sm3 hash，与服务端处理逻辑一致：
 * - 去除所有空白字符（\s，包括 U+0020、U+00A0 NBSP、U+2002~U+200A 各类空格等）
 * - 去除加号
 * - 单独保留 U+FEFF（BOM/零宽不换行空格），因为服务端会保留它
 */
function normalizeStringForSm3(str) {
  if (typeof str !== 'string') return str
  let result = str.replace(/\+/g, '')
  // 用 \s 去除所有空白字符（与后端一致），但保留 U+FEFF（后端不去除它）
  result = result
    .split('')
    .filter((char) => {
      if (char.charCodeAt(0) === 0xfeff) return true // 保留 U+FEFF
      return !/\s/.test(char)
    })
    .join('')
  result = result.trim()
  return result
}

/**
 * 递归规范化对象/数组中所有字符串值，用于 JSON body 的 sm3 hash。
 * 对每个字符串字段值单独做规范化，而非对整个 JSON 字符串全局去空格，
 * 避免 JSON 结构字符（如 { " : }）中的空格被误删。
 */
function normalizeObjectStringValuesForSm3(obj) {
  if (typeof obj === 'string') return normalizeStringForSm3(obj)
  if (obj === null || typeof obj !== 'object') return obj
  if (Array.isArray(obj))
    return obj.map((item) => normalizeObjectStringValuesForSm3(item))
  const out = {}
  for (const key of Object.keys(obj)) {
    const val = obj[key]
    out[key] =
      typeof val === 'string'
        ? normalizeStringForSm3(val)
        : normalizeObjectStringValuesForSm3(val)
  }
  return out
}

/**
 * 对参与 sm3 签名的 params 字符串做规范化，与服务端处理逻辑一致。
 * - JSON body：解析后逐字段规范化字符串值，再 stringify
 * - query string：逐 value 规范化
 * - 保留 &Mediaxsecurity= 后缀不变
 */
function normalizeParamsForSm3(paramsStr) {
  if (typeof paramsStr !== 'string' || !paramsStr) return paramsStr
  const idx = paramsStr.indexOf('&Mediaxsecurity=')
  if (idx === -1) return paramsStr
  const bodyPart = paramsStr.slice(0, idx)
  const suffix = paramsStr.slice(idx)
  let normalizedBody = bodyPart
  const trimmed = bodyPart.trim()
  if (trimmed.startsWith('{')) {
    try {
      const obj = JSON.parse(trimmed)
      normalizedBody = JSON.stringify(normalizeObjectStringValuesForSm3(obj))
    } catch (_) {
      normalizedBody = bodyPart.trim().replace(/\+/g, '')
    }
  } else {
    const pairs = bodyPart.split('&').filter(Boolean)
    normalizedBody = pairs
      .map((p) => {
        const i = p.indexOf('=')
        if (i === -1) return p
        const k = p.slice(0, i)
        const v = decodeURIComponent(p.slice(i + 1).replace(/\+/g, ' '))
        return k + '=' + (typeof v === 'string' ? normalizeStringForSm3(v) : v)
      })
      .join('&')
  }
  return normalizedBody + suffix
}

// pugc使用
const requestRetryCounts = new Map()

const _axios = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development' &&
    typeof PROJECT_CONFIG !== 'undefined' &&
    typeof PROJECT_CONFIG.BASE_URL !== 'undefined'
      ? PROJECT_CONFIG.BASE_URL
      : '', // api的base_url
  timeout: 20000 // request timeout
})

let timeoutMesFlag = false
function isEmptyData(data) {
  if (data === null) return true
  if (typeof data === 'string' && data.trim() === '') return true
  if (Array.isArray(data) && data.length === 0) return true
  if (
    typeof data === 'object' &&
    !Array.isArray(data) &&
    Object.keys(data).length === 0
  )
    return true
  return false
}
/**
 * 接口请求前置拦截器
 * @param config
 * @returns {*}
 */
function requestInterceptor(config) {
  // config.vconfig.noShowLoading为true，则弹框不需要在确定按钮上加loading icon
  if (!(config.vconfig && config.vconfig.noShowLoading)) {
    window.dialogWatcherPlugin?.showLoading()
  }
  // 得这么写，这玩意儿还可能是null，虽然不知道哪儿传的
  if (config.vconfig && config.vconfig.isMicro) {
    config.url =
      (config.vconfig.microPrefix || window.__API_PREFIX__ || '') + config.url
  }
  // 会员管理部分接口参数是直接作为变量拼在在url上---'/prodb/baas-message/sender/v1/{id}/status/{status}/{num}',这部分参数不参与生成服务端hashCode
  // 处理 pathParams，删除 config.params 中与 pathParams 相同的键
  if (
    config.pathParams &&
    typeof config.pathParams === 'object' &&
    config.params
  ) {
    Object.keys(config.pathParams).forEach((key) => {
      if (config.params && config.params.hasOwnProperty(key)) {
        delete config.params[key]
      }
    })
  }
  // 加一个接口定制超时参数
  if (config.vconfig && config.vconfig.timeout) {
    config.timeout = config.vconfig.timeout
  }
  /**
   * 如果是微服务的api，需要把baseURL改为''
   */
  let requestPrefix = ''
  if (config.url.indexOf('http') === 0) {
    //说明是带了域名的，需要获取其前缀
    requestPrefix = config.url.split('://')[1]
    if (requestPrefix) {
      requestPrefix = '/' + requestPrefix.split('/')[1]
    }
  } else {
    requestPrefix = config.url
  }
  if (isMicroServiceApi(requestPrefix)) {
    config.baseURL = ''
    /**
     * 从localStorage中获取token
     * token在登录成功时写入localStorage
     */
    let loginInfo = null
    //非云端稿库环境，且访问的是云端稿库资源，请求使用云端稿库网关
    if (
      window.processEnvMode !== 'RR' &&
      (window.moduleName === 'module-distinct' ||
        window.moduleName === 'module-distinct-open') &&
      outUrl.indexOf(config.url) === -1
    ) {
      if (config.url.indexOf('http') !== 0) {
        config.url = (window.PROJECT_CONFIG.MEDIARR_CORE || '') + config.url
      }

      loginInfo = localStorage.getItem('rrLoginUserInfo')
    } else {
      loginInfo = localStorage.getItem('loginInfo')
    }

    // 云端稿库稿件选用并编辑时， 在APP库和稿源库的编辑页中，保存时调用云端稿库的（新增选用记录接口），需更换云端稿库的网关和url
    if (config.url === '/mediax-repository/selection/add') {
      if (config.url.indexOf('http') !== 0) {
        config.url = (window.PROJECT_CONFIG.MEDIARR_CORE || '') + config.url
      }
      loginInfo = localStorage.getItem('rrLoginUserInfo')
    }

    try {
      loginInfo = JSON.parse(loginInfo)
    } catch (err) {
      console.log(err)
    }
    // PUGC平台的所有接口，不走这个token校验
    if (loginInfo && loginInfo.authToken && window.processEnvMode != 'PUGC') {
      config.headers.MediaxAuth = loginInfo.authToken

      let d = new Date().getTime()
      if (window.localStorage.getItem('yqSystemTime')) {
        d = Number(d) + Number(window.localStorage.getItem('yqSystemTime'))
      }

      config.headers.MediaxSecurity =
        md5(loginInfo.userCode + '.' + d) + ';' + d
    } else {
      config.headers['source'] = 'batman'
      const requestId = config.url + config.method
      // 设置初始重试次数
      if (!requestRetryCounts.has(requestId)) {
        requestRetryCounts.set(requestId, 0)
      }
      store.dispatch('batman/GET_TICKET')
      if (loginInfo && loginInfo.authToken) {
        config.headers['s-token'] = loginInfo.authToken
      }
      if (store.state.batman.Ticket) {
        config.headers['Ticket'] = store.state.batman.Ticket
      }
    }
  }
  let _hub =
    config.vconfig && config.vconfig.hub
      ? {
          hub: config.vconfig.hub
        }
      : {}
  if (
    process.env.NODE_ENV !== 'development' &&
    process.env.NODE_ENV !== 'production'
  ) {
    let _config = Options.options.getAccessUrl({
      url: config.url,
      params: config.params || config.data,
      method: config.method,
      ..._hub
    })
    var _req = Object.assign({}, config, _config)
    _req.method = 'post'
    _req.data = _req.params || _req.data
    _req.data = qs.stringify(_req.data)
    _req.params = null
    return _req
  } else {
    if (config.vconfig && config.vconfig.hubForward && config.vconfig.hub) {
      let data = {
        url: config.url,
        params: config.params || config.data,
        method: config.method
      }
      config.url = config.vconfig.hub
      config.method = 'post'
      config.data = data
      config.params = null
    }
    if (config.url.startsWith('/prodb/member/spc/v1/')) {
      // 会员专用请求头
      let operatorName = encodeURIComponent(
        JSON.parse(localStorage.getItem('loginInfo') || '{}').userName
      )
      config.headers.operatorName = operatorName
    }

    let methodType = config.method.toUpperCase()
    const dn = getRandom11DigitNumber()
    // 所有上传相关的接口
    if (
      (config.headers['contentType'] &&
        config.headers['contentType'] === 'multipart/form-data') ||
      (config.headers['Content-Type'] &&
        config.headers['Content-Type'] === 'multipart/form-data')
    ) {
      // 如果上传类型是'multipart/form-data' && data是FormData这样处理
      if (config.data && config.data instanceof FormData) {
        handleFormDataDn(config.data, window.processEnvMode == 'PUGC')
        config.data.append('dn', dn)
      }
    } else if (
      config.headers['Content-Type'] &&
      config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      if (config.data && typeof config.data === 'string') {
        config.data = handleStringDataDn(
          config.data,
          window.processEnvMode == 'PUGC'
        )
        config.data = config.data + `${config.data ? '&' : ''}dn=${dn}`
      } else if (config.data && config.data instanceof FormData) {
        handleFormDataDn(config.data, window.processEnvMode == 'PUGC')
        config.data.append('dn', dn)
      } else if (config && isEmptyData(config.data)) {
        config.data = `dn=${dn}`
      }
    } else {
      if (methodType !== 'POST' && methodType !== 'PUT') {
        // Get 或者 Delete 方法
        config.url = handleStringDataDn(
          config.url,
          window.processEnvMode == 'PUGC'
        )
        const arr = config.url.split('?')
        let params = arr[1] || ''
        params = params + `${params ? '&' : ''}dn=${dn}`
        config.url = arr[0] + '?' + params
      } else if (!config.data || JSON.stringify(config.data) === '{}') {
        // POST 或者 PUT 方法 但是没有 data 参数
        config.data = {
          dn: dn
        }
      } else if (config.data instanceof Object) {
        // POST 或者 PUT 方法 且有 data 参数
        config.data.dn = dn
      }
    }
    // 如果再有特殊逻辑 在这里追加else

    // 处理PUGC投稿平台部分接口，由于url含有dn参数，导致报错
    if (window.processEnvMode == 'PUGC') {
      const apiList = ['/batman/security/token']
      const isMatched = apiList.some((apiPath) => config.url.includes(apiPath))
      if (isMatched) config.url = removeDnParameter(config.url)
    }

    // 新的加密逻辑MediaxSecurity 生成hashCode
    if (config.headers.MediaxSecurity) {
      let params = ''
      // console.log('___________________________________', config.url, config.headers['Content-Type'])
      let MediaxSecurity = config.headers.MediaxSecurity
      if (config.vconfig && config.vconfig.isSimpleSecurity) {
        params = `dn=${dn}`
      } else if (
        methodType !== 'POST' &&
        methodType !== 'PUT' &&
        config.url.includes('?')
      ) {
        let np = config.url.split('?')[1]
        if (!config.params) {
          params = np
        } else {
          params = np
          if (objectToQueryString(config.params)) {
            params += '&' + objectToQueryString(config.params)
          }
          params = params.trim().replace(/[\s\u3000]/g, '')
        }
      } else if (
        (methodType === 'POST' || methodType === 'PUT') &&
        config.data
      ) {
        if (
          (config.headers['contentType'] &&
            config.headers['contentType'] === 'multipart/form-data') ||
          (config.headers['Content-Type'] &&
            config.headers['Content-Type'] === 'multipart/form-data')
        ) {
          // 如果上传类型是'multipart/form-data' && data是FormData这样处理
          if (config.data && config.data instanceof FormData) {
            params = `dn=${dn}`
          }
        } else if (
          config.headers['Content-Type'] &&
          config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
        ) {
          if (
            config.data &&
            (typeof config.data === 'string' || config.data instanceof FormData)
          ) {
            params = `dn=${dn}`
          }
        } else {
          // POST方法 赋值：直接使用 config.data 构建 params（保留零宽字符），后续由 normalizeParamsForSm3 处理
          // 这样构建的 params 与服务端收到的数据一致，然后再规范化用于 hash
          params = manualDecode(JSON.stringify(config.data)).trim()
          // 不再对整段字符串做 .replace(/[\s\u3000]/g, '')，后续由 normalizeParamsForSm3 统一处理
        }
      } else if (
        methodType !== 'POST' &&
        config.params &&
        config.params !== ''
      ) {
        // 其他方法 赋值
        params = objectToQueryString(config.params)
          .trim()
          .replace(/[\s\u3000]/g, '')
      } else if (
        (config.data && config.params) ||
        (methodType === 'POST' && config.params)
      ) {
        // 不赋值
        console.log('ERROR URL PARAMS::::::::::', config.url)
      }
      if (
        params &&
        config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
      ) {
        params = decodeURIComponent(params)
        if (params[0] === '"') {
          params = params.replace(/^"(.*)"$/, '$1')
        }
      }
      // params = data或者params + & + 原来的MediaxSecurity
      if (params && MediaxSecurity) {
        // params 赋值的情况 Mediaxsecurity拼在后面
        params = params + `&Mediaxsecurity=${MediaxSecurity}`
      } else if (params == '' && MediaxSecurity) {
        // params 未赋值的情况 Mediaxsecurity也需要处理
        params = `Mediaxsecurity=${MediaxSecurity}`
      }
      params = params.trim().replace(/\+/g, '')
      // 仅对参与签名的 params 做规范化，用于 sm3；不修改传给后台的 config.data/config.params
      // 注意：normalizeParamsForSm3 会保留零宽字符（包括 BOM U+FEFF），确保与后端用于加密的字符串一致
      // params = normalizeParamsForSm3(params)
      // if(config.vconfig && config.vconfig.isSimpleSecurity) {
      //   console.log('config.isSimpleSecurity!!!!!!');
      //   console.log('params && MediaxSecurity:::::::::::::::::', params)
      //   console.log('sm3(params):::::::::::: ', sm3(params))
      // }
      //非云端稿库环境，且访问的是云端稿库资源，版本在330以下的，不加';' + sm3(params)
      if (
        window.processEnvMode !== 'RR' &&
        (window.moduleName === 'module-distinct' ||
          window.moduleName === 'module-distinct-open')
      ) {
        if (version && isVersionBelow(version, '3.3.0') > -1) {
          config.headers['MediaxSecurity'] = MediaxSecurity + ';' + sm3(params)
        } else {
          if (outUrl.indexOf(config.url) > -1) {
            config.headers['MediaxSecurity'] = MediaxSecurity
          } else {
            config.headers['MediaxSecurity'] =
              MediaxSecurity + ';' + sm3(params)
          }
        }
      } else {
        config.headers['MediaxSecurity'] = MediaxSecurity + ';' + sm3(params)
      }
    }
    // 开发环境设置单点登录authtoken
    // if (config.url.indexOf('hub') > -1) config.headers.authToken = '69367c43-2f6c-4ff4-96b2-0c8831444e03'
    return config
  }
}

/**
 * 错误信息异常拦截器
 * @param error
 * @returns {Promise}
 */
function responseErrorHandler(error) {
  console.log('error', error)
  // (视频号-微信视频号)业务需要获取超时状态
  if (
    error.code === 'ECONNABORTED' &&
    error.config.url === '/mediax-articlevideo/vd/accounts/authorizeUrl'
  ) {
    return Promise.reject(error)
  }
  console.log(
    !isMbdWhiteListApi(error.config.url),
    error.config.url,
    '----------111----------'
  )
  console.log('错误')
  if (error.response.status === 401 && !isMbdWhiteListApi(error.config.url)) {
    goLogout()
  }
  return Promise.reject(error)
}
// newsedit 注释开始
_axios.interceptors.request.use(
  (config) => {
    return requestInterceptor(config)
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

_axios.interceptors.request.use((config) => {
  if (config.vconfig) {
    // 默认有loading
    if (!config.vconfig.neverLoading) {
      loading.start()
    }
  } else {
    loading.start()
  }
  return config
})

// 用户没有权限时退出当前系统进入登陆页面
_axios.interceptors.response.use(
  (response) => response,
  (error) => {
    return responseErrorHandler(error)
  }
)

let isRefreshing = false
let failedQueue = []
// respone interceptor
_axios.interceptors.response.use(
  async (response) => {
    if (
      !response?.config?.vconfig?.noHideLoading &&
      response?.config?.url.indexOf('actions/preaction') === -1
    ) {
      window.dialogWatcherPlugin?.hideLoading()
      window.dialogWatcherPlugin?.removeAllLoadingIcons()
    }
    // if(response.config.url)
    if (response.data.status === 401) {
      if (window.localStorage.getItem('tianmuyun') === null) {
        // 单独处理PUGC投稿平台
        if (window.processEnvMode == 'PUGC') {
          // 关闭遮罩层
          loading.close()
          // 获取请求 ID
          // 格式化请求url,确保相同请求唯一
          const queryUrl = response.config.url.split('?')[0]
          const requestId = queryUrl + response.config.method
          const currentCount = requestRetryCounts.get(requestId) || 0
          // 最大请求5次
          if (currentCount < 5) {
            // 更新重试次数
            requestRetryCounts.set(requestId, currentCount + 1)

            if (!isRefreshing) {
              isRefreshing = true
              try {
                // 刷新 Ticket-token
                await store.dispatch('batman/FETCH_TOKEN')
                store.dispatch('batman/GET_TICKET')
                // 刷新 Stoken
                await store.dispatch('batman/REFRESH_ACCESS_TOKEN')
                isRefreshing = false
                // failedQueue = [];
                if (store.state.batman.Ticket) {
                  response.config.headers['Ticket'] = store.state.batman.Ticket
                }
                loading.close()

                // 发送当前请求
                return _axios(response.config)
              } catch (refreshError) {
                isRefreshing = false
                return Promise.reject(refreshError)
              } finally {
                // 在刷新令牌后处理队列中的请求
                handleFailedQueue()
              }
            } else {
              // 如果已经有请求在刷新 token，则将当前请求添加到队列
              return new Promise((resolve) => {
                failedQueue.push(() => {
                  if (store.state.batman.Ticket) {
                    response.config.headers['Ticket'] =
                      store.state.batman.Ticket
                  }
                  // 发送请求
                  _axios(response.config)
                    .then((resolvedResponse) => resolve(resolvedResponse))
                    .catch((error) => {
                      console.error('Request failed in queue:', error)
                      resolve(Promise.reject(error))
                    })
                })
              })
            }
          } else {
            loading.close()
            requestRetryCounts.clear()
            return Promise.reject(response)
          }
        }
        window.localStorage.removeItem('loginInfo')
        Message.error({ message: '登录过期，即将返回登录页', duration: 2000 })
        setTimeout(() => {
          if (location.search && location.search.indexOf('?link') === 0) {
            location.href = '/login' + location.search
          } else {
            location.href = '/login'
          }
        }, 2000)
      }
    }
    if (response.config && response.config.vconfig) {
      if (!response.config.vconfig.neverLoading) {
        loading.close()
      }
    } else {
      loading.close()
    }
    // 如果是 arraybuffer 类型且包含错误信息
    if (
      response.config.responseType === 'arraybuffer' &&
      response.data instanceof ArrayBuffer
    ) {
      const decoder = new TextDecoder('utf-8')
      const decodedString = decoder.decode(response.data)

      try {
        const errorObj = JSON.parse(decodedString)
        response.data = errorObj
      } catch (e) {
        // console.log('正常内容下载')
        // 解析失败则保持原样
      }
    }
    if (
      ((response.config.vconfig &&
        !response.config.vconfig.isHideErrorMessage) ||
        !response.config.vconfig) &&
      response.data &&
      typeof response.data === 'object' &&
      response.data.status &&
      response.data.status !== 0
    ) {
      let m =
        response.data.message || response.data.message !== ''
          ? `${response.data.message}`
          : `[status:${response.data.status}]`
      if (
        m.indexOf('非法访问：无认证信息，请重新登录') < 0 &&
        ![1025, 1026, 1125, 1124, 1027, 1130].includes(response.data.status)
      ) {
        if (response.data.status === 10013) {
          // 无权限
          m = '您当前不具备该数据的权限，您可以申请相关权限后再试。'
        }
        //自动登录错误提示屏蔽
        if (!response.config.closeErrorMsg) {
          // 针对10013错误进行防重复提示处理
          if (response.data.status === 10013) {
            // 使用全局变量防止重复弹出提示
            if (!window.permissionDeniedMessageShown) {
              window.permissionDeniedMessageShown = true
              Message({
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: m,
                type: 'error',
                duration: 5 * 1000
              })

              // 3秒后允许再次显示提示
              setTimeout(() => {
                window.permissionDeniedMessageShown = false
              }, 3000)
            }
          } else {
            Message({
              showClose: true,
              dangerouslyUseHTMLString: true,
              message: m,
              type: 'error',
              duration: 5 * 1000
            })
          }
          if (
            response.data.status === 400 &&
            window.localStorage.getItem('tianmuyun')
          ) {
            if (response.config.url !== '/mediax-content/ai/title') {
              window.localStorage.removeItem('loginInfo')
              setTimeout(() => {
                location.href = '/login'
              }, 2000)
            }
          }
        } else {
          return Promise.resolve(response)
        }
      }
    }
    //  && rocess.env.NODE_ENV !== 'development'
    // 如果是pugc的话，排除编写稿件接口，其他互踢要退出登录，并Url上携带上siteId
    if (window.processEnvMode == 'PUGC') {
      // 登录互踢
      const pathnameWhiteList = [
        // '/service/mediacloud-reporter/articleText', // 新建/编辑文章稿
        // '/service/mediacloud-reporter/articlePics', // 新建/编辑图集稿
        // '/service/mediacloud-reporter/articleVideos', // 新建/编辑视频稿
      ]
      if (response.data.status === 403) {
        if (!pathnameWhiteList.includes(window.location.pathname)) {
          Message.warning(`抱歉，当前账号已在其他设备登录！`)
          setTimeout(() => {
            let siteId = localStorage.getItem('siteId')
            window.location.href = `/login?siteId=${siteId}`
          }, 1000)
        } else {
          window.dispatchEvent(
            new CustomEvent('pugcSaveArticle', {
              detail: { url: response.config.url }
            })
          )
        }
      }
    } else {
      // 登录互踢
      if (response.data.status === 1022) {
        setTimeout(() => {
          goLogout()
        }, 1000)
      }
    }
    return response
  },
  (error) => {
    window.dialogWatcherPlugin?.hideLoading()
    window.dialogWatcherPlugin?.removeAllLoadingIcons()
    loading.close()
    // (视频号-微信视频号)业务需要获取超时状态
    if (
      error.code === 'ECONNABORTED' &&
      error.config.url === '/mediax-articlevideo/vd/accounts/authorizeUrl'
    ) {
      return Promise.reject(error)
    }
    console.log(
      'err' + error,
      typeof error,
      JSON.stringify(error),
      JSON.stringify(error) !== '{}'
    )
    if (window.localStorage.getItem('tianmuyun')) {
      window.localStorage.removeItem('loginInfo')
      Message.error({ message: '登录过期，即将返回登录页', duration: 2000 })
      setTimeout(() => {
        location.href = '/login'
      }, 2000)
    }
    // vconfig.isHideErrorMessage 有一些接口不需要将错误信息弹出来，可将vconfig.isHideErrorMessage设置为true
    // TODO 需要处理一下401的情况，401代表环境超时，此时应该停掉所有的请求，目前只是将错误信息只弹出了一次，其余的都拦截了，并没有停掉请求
    if (JSON.stringify(error) !== '{}') {
      if (
        error.response.status === 500 &&
        error.config.vconfig &&
        !error.config.vconfig.isHideErrorMessage
      ) {
        Message({
          showClose: true,
          message: error.response.data.message,
          type: 'error',
          duration: 5 * 1000
        })
      } else if (
        error.response.status !== 10013 &&
        error.response.status !== 400 &&
        (!timeoutMesFlag || error.response.status !== 401) &&
        ((error.config.vconfig && !error.config.vconfig.isHideErrorMessage) ||
          !error.config.vconfig)
      ) {
        Message({
          showClose: true,
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
        if (error.response.status === 401) timeoutMesFlag = true
      } else if (
        !error.response.status === 401 &&
        !error.response.status !== 400 &&
        error.config.vconfig.isHideErrorMessage
      ) {
      } else if (error.response.status !== 10013) {
        Message({
          showClose: true,
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

function logout() {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = '/html/portal/expire_session.jsp'
  document.getElementsByTagName('body')[0].appendChild(iframe)
  window.localStorage.removeItem('loginInfo')
  sessionStorage.removeItem('siteId')
  setTimeout(() => {
    let result = ''
    let host = window.location.host
    let pos = host.indexOf('.')
    let hostHead = host.substring(0, pos)
    let tenantHost = hostHead.substring(hostHead.lastIndexOf('-'))
    if (window.founderMediaCloudMamSystem === 'founderMediaCloudMamSystem') {
      // 判断如果是音视频系统的话，退出到音视频的提示页
      result = window.location.protocol + '//' + host + '/group/guest'
    } else {
      result =
        window.location.protocol +
        '//portal' +
        tenantHost +
        host.substring(pos) +
        '/c/portal/logout'
    }
    if (window.socket) window.socket.close()
    window.location.href = result
  }, 0)
}
// newsedit 注释结束

//互踢后，退出系统
function goLogout() {
  localStorage.removeItem('loginInfo')
  localStorage.removeItem('rrLoginUserInfo')
  location.href = '/login'
}

// 在刷新令牌后处理队列中的请求
function handleFailedQueue() {
  if (failedQueue.length > 0) {
    // 使用 Promise.all 来并发处理所有等待中的请求
    Promise.all(failedQueue.map((fn) => fn()))
      .then((responses) => {
        // 处理所有响应
        console.log('All pending requests have been processed.')
      })
      .catch((errors) => {
        // 处理所有错误
        console.error(
          'Errors occurred while processing pending requests:',
          errors
        )
      })
      .finally(() => {
        // 清空队列
        failedQueue = []
      })
  }
}

/**
 * 移除str上的 dn 参数
 * @param {string} str 待处理的字符串
 * @returns {string} 处理后的字符串
 */
function removeDnParameter(str) {
  if (str.includes('?')) {
    const [path, queryString] = str.split('?')
    if (!queryString) return path
    const filteredParams = queryString
      .split('&')
      .filter((param) => !param.trim().toLowerCase().startsWith('dn='))
    return filteredParams.length > 0
      ? `${path}?${filteredParams.join('&')}`
      : path
  } else {
    const filtered = str
      .split('&')
      .filter((param) => !param.trim().toLowerCase().startsWith('dn='))
      .join('&')
    return filtered
  }
}
/**
 * 处理FormData中的dn参数，如果已存在则先删除
 * @param {FormData} data - FormData对象
 * @param {boolean} isPugcEnv - 是否为PUGC环境
 */
function handleFormDataDn(data, isPugcEnv) {
  if (isPugcEnv && data.has('dn')) {
    data.delete('dn')
  }
}
/**
 * 处理字符串数据中的dn参数，如果已存在则先删除
 * @param {string} data - 字符串数据
 * @param {boolean} isPugcEnv - 是否为PUGC环境
 * @returns {string} 处理后的字符串
 */
function handleStringDataDn(data, isPugcEnv) {
  if (isPugcEnv && data.indexOf('dn=') > -1) {
    return removeDnParameter(data)
  }
  return data
}

_axios.requestInterceptor = requestInterceptor
_axios.responseErrorHandler = responseErrorHandler
export default _axios
